import { render, staticRenderFns } from "./AnnualizationYear.vue?vue&type=template&id=036ddc38&scoped=true"
import script from "./AnnualizationYear.vue?vue&type=script&lang=js"
export * from "./AnnualizationYear.vue?vue&type=script&lang=js"
import style0 from "./AnnualizationYear.vue?vue&type=style&index=0&id=036ddc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ddc38",
  null
  
)

export default component.exports